import styled from 'styled-components';
import loading from '../../../assets/image/jd_loading.gif';

const Container = styled.div`
position: fixed;
top: 0;
left: 0;
right: 0;
bottom: 0;
z-index: 999;
display: flex;
justify-content: center;
align-items: center;

.loading {
  width: 1rem;
  height: 1rem;
  background: url('${loading}') center / 1rem 1rem no-repeat;
}
`;

export {
  Container,
}
